/**
 * 批量事务抽屉 V5.0 - 机场和供应商选择组件
 * 重构为哑组件，使用新的Context结构
 */

import React from "react";
import { Card, Row, Col, Checkbox, Select, Space, Tag } from "antd";
import { EnvironmentOutlined, ShopOutlined } from "@ant-design/icons";
import { useBatchTransactionContext } from "../context/BatchTransactionContext";

const { Option } = Select;

const AirportSupplierSelection = () => {
    // 使用重构后的Context，所有逻辑都在Hook中处理
    const {
        // 选择状态
        availableAirports,
        activeAirports,
        availableSuppliers,
        selectedSupplier,
        suppliersLoading,
        errors,

        // 计算属性
        isAllAirportsSelected,
        isIndeterminateAirports,

        // 操作方法
        handleAirportChange,
        handleSelectAllAirports,
        handleSupplierChange,

        // 事务数据状态（用于显示筛选信息）
        state: { selectedFlights, transactions },
    } = useBatchTransactionContext();

    // 交互策略：V5 中机场/供应商/产品选择在任何模式均可编辑
    const isReadOnly = false;

    // 计算筛选状态信息
    const getFilterStatus = () => {
        if (!activeAirports.length) return null;

        const totalFlights = selectedFlights.length;
        const visibleTransactions = transactions.length;

        return {
            totalFlights,
            visibleTransactions,
            selectedAirports: activeAirports,
        };
    };

    const filterStatus = getFilterStatus();

    return (
        <Card
            title={
                <Space>
                    <EnvironmentOutlined />
                    机场与供应商选择
                </Space>
            }
            size="small"
            style={{ marginBottom: 16 }}
        >
            <Row gutter={[16, 16]}>
                {/* 机场选择 */}
                <Col span={12}>
                    <Checkbox indeterminate={isIndeterminateAirports} onChange={(e) => handleSelectAllAirports(e.target.checked)} checked={isAllAirportsSelected} disabled={isReadOnly || availableAirports.length === 0}>
                        全选 ({activeAirports.length}/{availableAirports.length})
                    </Checkbox>
                    <Checkbox.Group value={activeAirports} onChange={handleAirportChange} disabled={isReadOnly} style={{ marginLeft: 8 }}>
                        <Row gutter={[8, 8]}>
                            {availableAirports.map((airport) => (
                                <Col key={airport}>
                                    <Checkbox value={airport}>
                                        <Tag color="blue" style={{ margin: 0 }}>
                                            {airport}
                                        </Tag>
                                    </Checkbox>
                                </Col>
                            ))}
                        </Row>
                    </Checkbox.Group>
                </Col>

                {/* 供应商选择 */}
                <Col span={12}>
                    <Select style={{ width: "100%" }} placeholder="请选择供应商" value={selectedSupplier?.id} onChange={handleSupplierChange} loading={suppliersLoading} disabled={isReadOnly || !activeAirports.length} showSearch optionFilterProp="children">
                        {availableSuppliers.map((supplier) => (
                            <Option key={supplier.id} value={supplier.id}>
                                <Space>
                                    <ShopOutlined />
                                    {supplier.name}
                                </Space>
                            </Option>
                        ))}
                    </Select>
                </Col>

                {/* 产品选择（V4交互：改由事务表顶部“批量修改产品”按钮触发模态，不在此处选择） */}
            </Row>
        </Card>
    );
};

export default AirportSupplierSelection;
